import { FaceIdErrors } from 'src/app/shared/interfaces/face-id.interface';

export enum StaticAssets {
  TCEA = 'tcea.json',
  accountNames = 'account-names.json',
  genericError = 'generic-error.json',
  suggestionData = 'ocr-suggestions.json',
  performanceData = 'performance-data.json',
  mobileDerivation = 'mobile-derivation.json',
  faceIdSuggestions = 'face-id-suggestions.json'
}

export interface OcrSuggestionResponse {
  instructions: OcrSuggestions[];
  suggestionTitle: string;
  continueBtn: string;
  initiateBtn: string;
}

export interface OcrSuggestions {
  mainIcon: string;
  data: Suggestions[];
}

export interface Suggestions {
  text: string;
  icon: string;
  alt: string;
  description?: FaceIdErrors;
}

export interface GenericErrorResponse {
  icon: string;
  title: string;
  principal_message: string;
  button_message: string;
}

export interface PerformanceData {
  dataDog: {
    preProdState: boolean,
    dataDogState: boolean,
    sampleRate: number
  };
  jointState: boolean;
  isRetakeActive: boolean;
  showQR: boolean;
  useFlagr: boolean;
}

export interface Suggestions {
  text: string;
  icon: string;
  alt: string;
  description?: FaceIdErrors;
}
